// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"8ec04563","93":"8661db1c"}[chunkId] + ".chunk.js";
};